import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Event from "./pages/event/event";
import Login from "./pages/login/Login";
import Singup from "./pages/singup/Singup";

import "./index.css";
import { AuthProvider } from "./services/auth/AuthContext";
import PrivateRoute from "./navigation/privateRoute";
import {
  EVENT,
  FORGOT_PASSWORD,
  HOME,
  LOGIN,
  SINGUP,
} from "./utils/app-routes";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";

if ("serviceWorker" in navigator && "PushManager" in window) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path={LOGIN} element={<Login />} />
          <Route path={SINGUP} element={<Singup />} />
          <Route path={FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={HOME} element={<PrivateRoute />}>
            <Route path={HOME} element={<Home />} />
            <Route path={EVENT} element={<Event />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);
